export default "__VITE_ASSET__DwVbelv0__"